import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flags/feature-flag.service';
import { environment } from 'src/environments/environment';

export const featureGuard = (feature: keyof typeof environment.features): CanActivateFn => {
  return () => {
    const router = inject(Router);
    const featureFlags = inject(FeatureFlagService);
    return featureFlags.get(feature) ? true : router.createUrlTree(['/home']);
  };
};
